import { AdminGlassDisclosure } from '@/components/admin/AdminGlassDisclosure';

const STEPS = [
  { n: '1', title: 'Категория', hint: 'Раздвижные, рулонные… — порядок перетаскиванием' },
  { n: '2', title: 'Подтип', hint: 'Карточка в каталоге. Порядок ≡ = как на витрине. Глаз — скрыть' },
  { n: '3', title: 'Система', hint: 'Таб в конфигураторе: цены, артикулы, фото' },
];

type Props = {
  step: 1 | 2 | 3;
};

export function AdminCatalogGuide({ step }: Props) {
  return (
    <AdminGlassDisclosure
      accent="cyan"
      defaultOpen={step === 1}
      density="compact"
      title="Как устроен каталог"
      subtitle="Ветка → подтип → система (PIM)"
    >
      <div className="px-3 pb-3 space-y-3">
        <div className="grid grid-cols-3 gap-1.5">
          {STEPS.map((s) => {
            const active = Number(s.n) === step;
            return (
              <div
                key={s.n}
                className="rounded-xl px-2 py-2 text-center"
                style={{
                  background: active ? 'rgba(99,179,237,0.15)' : 'rgba(255,255,255,0.04)',
                  border: active ? '1px solid rgba(99,179,237,0.35)' : '1px solid rgba(255,255,255,0.08)',
                }}
              >
                <p className="text-[10px] font-bold" style={{ color: active ? '#63B3ED' : 'var(--text-3)' }}>
                  {s.n}. {s.title}
                </p>
              </div>
            );
          })}
        </div>
        <p className="text-[10px] leading-relaxed" style={{ color: 'var(--text-3)' }}>
          {STEPS[step - 1].hint}
        </p>
      </div>
    </AdminGlassDisclosure>
  );
}
